import { ClosedOneWayCircle } from '@creditornot/cb-icons';
import { colors } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import { VenueAvailabilityStatus } from 'modules/venue-availability-status/types';

const InactiveIcon = styled(ClosedOneWayCircle).attrs({ width: 10, height: 10 })`
  fill: ${colors.strawberry100};
`;

const StatusLight = styled.div<{ status: VenueAvailabilityStatus }>`
  border-radius: 50%;
  height: 10px;
  width: 10px;
  opacity: 1;
  background-color: ${({ theme, status }) => {
    switch (status) {
      case VenueAvailabilityStatus.IPAD_NOT_ALIVE:
      case VenueAvailabilityStatus.OFFLINE:
        return colors.strawberry100;
      case VenueAvailabilityStatus.CLOSED:
        return theme.cbThemeMode === 'light' ? colors.pepper32 : colors.pepper32;
      default:
        return colors.lime100;
    }
  }};
`;

type AvailabilityStatusProps = {
  status: VenueAvailabilityStatus;
};

export const AvailabilityStatus = ({ status }: AvailabilityStatusProps) => {
  if (status === VenueAvailabilityStatus.INACTIVE) {
    return <InactiveIcon />;
  }
  return <StatusLight status={status} />;
};
